'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import styles from './SkinTemperatureModal.module.css';

export const SkinTemperatureModal = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('ring');
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="skin-temperature-modal-heading"
    >
      <div className="container">
        <h4 id="skin-temperature-modal-heading">
          {t('ring.bentoRecoverySection.skinTemperatureCard.modal.head')}
        </h4>
        <h3>
          {t('ring.bentoRecoverySection.skinTemperatureCard.modal.subHead')}
          <br />{' '}
          {t('ring.bentoRecoverySection.skinTemperatureCard.modal.subHeadB')}
        </h3>
        <div className="modal-items">
          <div className="item">
            {/* <h5>Sleep Debt </h5> */}
            <p className="text-mid">
              {t(
                'ring.bentoRecoverySection.skinTemperatureCard.modal.cardA.desc',
              )}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('skinTemperatureModal.content.ariaLabel')}
            >
              <Image
                src={'web_v2/ring-buy/recovery/png/flip/tempFlip.png'}
                fill
                alt=""
                className="skin-temperature-flip"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
